export default "__VITE_ASSET__PDUxXj5y__"